// Port of api/fuel/app/classes/filter/search/games/filters/query/game/exclude.php
export default {
	name: 'game.exclude',
	priority: 4,
	require: function(config, filter) {
		return filter.games && filter.games.exclude && filter.games.exclude.length > 0
	},
	run: function(config, filter, data, query) {
		query.where('g.game_id', 'not in', filter.games.exclude)
	}
}
